export const DefaultTranslationappFrame = [
  {
    tabId: "appFrame",
    tabSectionKey: "mainMenu",
    attributeKey: "home",
    attributeValue: "",
  },
  {
    tabId: "appFrame",
    tabSectionKey: "mainMenu",
    attributeKey: "adminConsole",
    attributeValue: "",
  },
  {
    tabId: "appFrame",
    tabSectionKey: "adminPortalMenu",
    attributeKey: "getBack",
    attributeValue: "",
  },
  {
    tabId: "appFrame",
    tabSectionKey: "adminPortalMenu",
    attributeKey: "portalDesign",
    attributeValue: "",
  },
  {
    tabId: "appFrame",
    tabSectionKey: "adminPortalMenu",
    attributeKey: "portalTranslation",
    attributeValue: "",
  },
  {
    tabId: "appFrame",
    tabSectionKey: "adminPortalMenu",
    attributeKey: "portalPage",
    attributeValue: "",
  },
  {
    tabId: "appFrame",
    tabSectionKey: "adminPortalMenu",
    attributeKey: "portalSetting",
    attributeValue: "",
  },
  {
    tabId: "appFrame",
    tabSectionKey: "adminPortalMenu",
    attributeKey: "assignmentAssignement",
    attributeValue: "",
  },
  {
    tabId: "appFrame",
    tabSectionKey: "adminPortalMenu",
    attributeKey: "userAttributes",
    attributeValue: "",
  },
  {
    tabId: "appFrame",
    tabSectionKey: "navBar",
    attributeKey: "search",
    attributeValue: "",
  },
  {
    tabId: "appFrame",
    tabSectionKey: "navBar",
    attributeKey: "viewProfile",
    attributeValue: "",
  },
  {
    tabId: "appFrame",
    tabSectionKey: "navBar",
    attributeKey: "logOut",
    attributeValue: "",
  },
] as const;

export const DefaultTranslationHome = [
  {
    tabId: "home",
    tabSectionKey: "header",
    attributeKey: "welcomeBack",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "header",
    attributeKey: "activeCourses",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "header",
    attributeKey: "activeAssignments",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "header",
    attributeKey: "complete",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "header",
    attributeKey: "partiallyComplete",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "header",
    attributeKey: "toBeComplete",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "header",
    attributeKey: "learners",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "header",
    attributeKey: "lessonsCompleted",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "header",
    attributeKey: "hoursOfLearning",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "assignements",
    attributeKey: "myAssignements",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "assignements",
    attributeKey: "filter",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "assignements",
    attributeKey: "filters",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "assignements",
    attributeKey: "hideFilters",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "assignements",
    attributeKey: "groups",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "assignements",
    attributeKey: "all",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "assignements",
    attributeKey: "completed",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "assignements",
    attributeKey: "pending",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "assignements",
    attributeKey: "save",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "assignements",
    attributeKey: "clearAll",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "assignements",
    attributeKey: "filtersApplied",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "assignements",
    attributeKey: "courses",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "assignements",
    attributeKey: "policies",
    attributeValue: "",
  },
  {
    tabId: "home",
    tabSectionKey: "assignements",
    attributeKey: "surveys",
    attributeValue: "",
  },
] as const;

export const DefaultTranslationLogin = [
  {
    tabId: "login",
    tabSectionKey: "loginHeader",
    attributeKey: "loginText",
    attributeValue: "",
  },
  {
    tabId: "login",
    tabSectionKey: "loginHeader",
    attributeKey: "loginDsc",
    attributeValue: "",
  },
  {
    tabId: "login",
    tabSectionKey: "loginForm",
    attributeKey: "email",
    attributeValue: "",
  },
  {
    tabId: "login",
    tabSectionKey: "loginForm",
    attributeKey: "password",
    attributeValue: "",
  },
  {
    tabId: "login",
    tabSectionKey: "loginForm",
    attributeKey: "btnForgotPassword",
    attributeValue: "",
  },
  {
    tabId: "login",
    tabSectionKey: "loginForm",
    attributeKey: "btnLogin",
    attributeValue: "",
  },
] as const;


export const DefaultTranslationForgotPassword = [
  {
    tabId: "forgot-password",
    tabSectionKey: "forgotPasswordHeader",
    attributeKey: "forgotPasswordText",
    attributeValue: "",
  },
  {
    tabId: "forgot-password",
    tabSectionKey: "forgotPasswordHeader",
    attributeKey: "forgotPasswordDsc",
    attributeValue: "",
  },
  {
    tabId: "forgot-password",
    tabSectionKey: "forgotPasswordForm",
    attributeKey: "email",
    attributeValue: "",
  },
  {
    tabId: "forgot-password",
    tabSectionKey: "forgotPasswordForm",
    attributeKey: "btnReset",
    attributeValue: "",
  },
  {
    tabId: "forgot-password",
    tabSectionKey: "forgotPasswordForm",
    attributeKey: "backTologin",
    attributeValue: "",
  },
  {
    tabId: "forgot-password",
    tabSectionKey: "forgotPasswordInfo",
    attributeKey: "checkMailText",
    attributeValue: "",
  },
  {
    tabId: "forgot-password",
    tabSectionKey: "forgotPasswordInfo",
    attributeKey: "checkMailDsc",
    attributeValue: "",
  },
  {
    tabId: "forgot-password",
    tabSectionKey: "forgotPasswordInfo",
    attributeKey: "notReceive",
    attributeValue: "",
  },
  {
    tabId: "forgot-password",
    tabSectionKey: "forgotPasswordInfo",
    attributeKey: "clickToResend",
    attributeValue: "",
  },
] as const;

export const DefaultTranslationNewPassword = [
  {
    tabId: "new-password",
    tabSectionKey: "setNewPasswordHeader",
    attributeKey: "setNewPasswordText",
    attributeValue: "",
  },
  {
    tabId: "new-password",
    tabSectionKey: "setNewPasswordHeader",
    attributeKey: "setNewPasswordDsc",
    attributeValue: "",
  },
  {
    tabId: "new-password",
    tabSectionKey: "setNewPasswordHeader",
    attributeKey: "activateAccount",
    attributeValue: "",
  },
  {
    tabId: "new-password",
    tabSectionKey: "setNewPasswordHeader",
    attributeKey: "activateAccountDsc",
    attributeValue: "",
  },
  {
    tabId: "new-password",
    tabSectionKey: "passwordReset",
    attributeKey: "btnActivate",
    attributeValue: "",
  },
  {
    tabId: "new-password",
    tabSectionKey: "passwordReset",
    attributeKey: "btnReset",
    attributeValue: "",
  },
  {
    tabId: "new-password",
    tabSectionKey: "setNewPasswordHeader",
    attributeKey: "activateAccountDsc",
    attributeValue: "",
  },
  {
    tabId: "new-password",
    tabSectionKey: "setNewPasswordForm",
    attributeKey: "newPassword",
    attributeValue: "",
  },
  {
    tabId: "new-password",
    tabSectionKey: "setNewPasswordForm",
    attributeKey: "repeatPassword",
    attributeValue: "",
  },
  {
    tabId: "new-password",
    tabSectionKey: "setNewPasswordForm",
    attributeKey: "criteria1",
    attributeValue: "",
  },
  {
    tabId: "new-password",
    tabSectionKey: "setNewPasswordForm",
    attributeKey: "criteria2",
    attributeValue: "",
  },
  {
    tabId: "new-password",
    tabSectionKey: "setNewPasswordForm",
    attributeKey: "criteria3",
    attributeValue: "",
  },
  {
    tabId: "new-password",
    tabSectionKey: "setNewPasswordForm",
    attributeKey: "criteria4",
    attributeValue: "",
  },
  {
    tabId: "new-password",
    tabSectionKey: "passwordReset",
    attributeKey: "passwordResetText",
    attributeValue: "",
  },
  {
    tabId: "new-password",
    tabSectionKey: "passwordReset",
    attributeKey: "passwordResetDsc",
    attributeValue: "",
  },
  {
    tabId: "new-password",
    tabSectionKey: "passwordReset",
    attributeKey: "btnLogin",
    attributeValue: "",
  },
] as const;

// TODO: ChangePassword

export const DefaultTranslationPortalConfiguration = [
  {
    tabId: "portal-configuration",
    tabSectionKey: "header",
    attributeKey: "portalConfiguration",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "portalGrid",
    attributeKey: "portals",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "portalGrid",
    attributeKey: "btnAddNewPortal",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "portalGrid",
    attributeKey: "btnManagePortals",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "portalGrid",
    attributeKey: "search",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "portalGrid",
    attributeKey: "name",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "portalGrid",
    attributeKey: "url",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "portalGrid",
    attributeKey: "languages",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "portalGrid",
    attributeKey: "authoringTool",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "portalGrid",
    attributeKey: "btnEdit",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "portalGrid",
    attributeKey: "showRows",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "portalGrid",
    attributeKey: "btnPrevious",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "portalGrid",
    attributeKey: "btnNext",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "portalGrid",
    attributeKey: "btnAll",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "addPortalModal",
    attributeKey: "addNewPortalText",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "addPortalModal",
    attributeKey: "name",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "addPortalModal",
    attributeKey: "subDomain",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "addPortalModal",
    attributeKey: "typeOfPortal",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "addPortalModal",
    attributeKey: "parentPortal",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "addPortalModal",
    attributeKey: "subPortal",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "addPortalModal",
    attributeKey: "additionalFeaturesServices",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "addPortalModal",
    attributeKey: "authoringTool",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "addPortalModal",
    attributeKey: "customTranslation",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "addPortalModal",
    attributeKey: "spoofingEmail",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "addPortalModal",
    attributeKey: "language",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "addPortalModal",
    attributeKey: "btnAddNewPortal",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "editLanguages",
    attributeKey: "editLanguageText",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "editLanguages",
    attributeKey: "language",
    attributeValue: "",
  },
  {
    tabId: "portal-configuration",
    tabSectionKey: "editLanguages",
    attributeKey: "btnSave",
    attributeValue: "",
  },
] as const;

export const DefaultTranslationPortalDesign = [
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "logoTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "logoSubtitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "certificateLogoTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "certificateLogoSubtitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "faviconTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "landscapeLogoTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "squareLogoTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "pixelsText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "uploadImageText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "backgroundTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "pageBackgroundImageTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "pageBackgroundImageSubtitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "backgroundTransparencyText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "pageBackgroundColorTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "primaryText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "secondaryText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "sidebarMenuTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "sidebarText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "textColorsTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "navbarTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "navbarBackgroundColorTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "navbarText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "navbarDropdownTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "backgroundColorText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "textColorText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "borderColorText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "buttonTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "primaryButtonTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "secondaryButtonTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "linkTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "assignmentStatusColorTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "pieChartTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "completedText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "pendingText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "overdueText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "bordersTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "shadowsTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "sizeText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "gpc",
    attributeKey: "colorText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "login",
    attributeKey: "poweredByText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "login",
    attributeKey: "loginPixelsText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "login",
    attributeKey: "loginPoweredByLogoDark",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "login",
    attributeKey: "loginPoweredByLogoLight",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "login",
    attributeKey: "loginLightMode",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "login",
    attributeKey: "loginDarkMode",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "login",
    attributeKey: "loginLightThemed",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "login",
    attributeKey: "loginDarkThemed",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "login",
    attributeKey: "inputFieldsSettingsTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "home",
    attributeKey: "cardsTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "home",
    attributeKey: "cardsSubtitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "home",
    attributeKey: "thumbnailTransparencyText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "home",
    attributeKey: "progressBarTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "home",
    attributeKey: "notStartedBarText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "home",
    attributeKey: "inProgressBarText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "home",
    attributeKey: "completedBarText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "home",
    attributeKey: "contentTypeColourTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "home",
    attributeKey: "coursesText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "home",
    attributeKey: "surveysText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "home",
    attributeKey: "policiesText",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "home",
    attributeKey: "overdueTitle",
    attributeValue: "",
  },
  {
    tabId: "portal-design",
    tabSectionKey: "home",
    attributeKey: "dateTitle",
    attributeValue: "",
  },
] as const;

export const DefaultTranslationPortalTranslation = [
  {
    tabId: "portal-translation",
    tabSectionKey: "general",
    attributeKey: "find&replace",
    attributeValue: "",
  },
  {
    tabId: "portal-translation",
    tabSectionKey: "general",
    attributeKey: "mainMenu",
    attributeValue: "",
  },
  {
    tabId: "portal-translation",
    tabSectionKey: "general",
    attributeKey: "adminPortalMenu",
    attributeValue: "",
  },
  {
    tabId: "portal-translation",
    tabSectionKey: "general",
    attributeKey: "navbar",
    attributeValue: "",
  },
  {
    tabId: "portal-translation",
    tabSectionKey: "general",
    attributeKey: "editTranslation",
    attributeValue: "",
  },
  {
    tabId: "portal-translation",
    tabSectionKey: "general",
    attributeKey: "headerText",
    attributeValue: "",
  },
  {
    tabId: "portal-translation",
    tabSectionKey: "general",
    attributeKey: "assignmentsText",
    attributeValue: "",
  },
  {
    tabId: "portal-translation",
    tabSectionKey: "general",
    attributeKey: "formText",
    attributeValue: "",
  },
  {
    tabId: "portal-translation",
    tabSectionKey: "general",
    attributeKey: "infoText",
    attributeValue: "",
  },
  {
    tabId: "portal-translation",
    tabSectionKey: "general",
    attributeKey: "passwordResetText",
    attributeValue: "",
  },
  {
    tabId: "portal-translation",
    tabSectionKey: "general",
    attributeKey: "portalGridText",
    attributeValue: "",
  },
  {
    tabId: "portal-translation",
    tabSectionKey: "general",
    attributeKey: "addPortalModalText",
    attributeValue: "",
  },
  {
    tabId: "portal-translation",
    tabSectionKey: "general",
    attributeKey: "editLanguagesText",
    attributeValue: "",
  },
  {
    tabId: "portal-translation",
    tabSectionKey: "general",
    attributeKey: "gpcText",
    attributeValue: "",
  },
  {
    tabId: "portal-translation",
    tabSectionKey: "general",
    attributeKey: "homeText",
    attributeValue: "",
  },
  {
    tabId: "portal-translation",
    tabSectionKey: "general",
    attributeKey: "loginText",
    attributeValue: "",
  },
] as const;

export const DefaultTranslationPortalPages = [
  {
    tabId: "portal-pages",
    tabSectionKey: "header",
    attributeKey: "portalPagesText",
    attributeValue: "",
  },
  {
    tabId: "portal-pages",
    tabSectionKey: "header",
    attributeKey: "portalPagesDsc",
    attributeValue: "",
  },
  {
    tabId: "portal-pages",
    tabSectionKey: "pages",
    attributeKey: "login",
    attributeValue: "",
  },
  {
    tabId: "portal-pages",
    tabSectionKey: "pages",
    attributeKey: "home",
    attributeValue: "",
  },
  {
    tabId: "portal-pages",
    tabSectionKey: "pages",
    attributeKey: "certificates",
    attributeValue: "",
  },
  {
    tabId: "portal-pages",
    tabSectionKey: "pages",
    attributeKey: "profile",
    attributeValue: "",
  },
  {
    tabId: "portal-pages",
    tabSectionKey: "pages",
    attributeKey: "visibleDsc",
    attributeValue: "",
  },
] as const;

export const DefaultTranslationPortalSettings = [
  {
    tabId: "portal-settings",
    tabSectionKey: "header",
    attributeKey: "portalSettingsText",
    attributeValue: "",
  },
  {
    tabId: "portal-settings",
    tabSectionKey: "header",
    attributeKey: "portalSettingsDsc",
    attributeValue: "",
  },
  {
    tabId: "portal-settings",
    tabSectionKey: "portalSettings",
    attributeKey: "editPortalSettings",
    attributeValue: "",
  },
  {
    tabId: "portal-settings",
    tabSectionKey: "portalSettings",
    attributeKey: "name",
    attributeValue: "",
  },
  {
    tabId: "portal-settings",
    tabSectionKey: "portalSettings",
    attributeKey: "subDomain",
    attributeValue: "",
  },
  {
    tabId: "portal-settings",
    tabSectionKey: "portalSettings",
    attributeKey: "connectedPortals",
    attributeValue: "",
  },
  {
    tabId: "portal-settings",
    tabSectionKey: "portalSettings",
    attributeKey: "connectedPortals",
    attributeValue: "",
  },
  {
    tabId: "portal-settings",
    tabSectionKey: "portalSettings",
    attributeKey: "additionalFeaturesServices",
    attributeValue: "",
  },
  {
    tabId: "portal-settings",
    tabSectionKey: "portalSettings",
    attributeKey: "authoringTool",
    attributeValue: "",
  },
  {
    tabId: "portal-settings",
    tabSectionKey: "portalSettings",
    attributeKey: "spoofingEmail",
    attributeValue: "",
  },
  {
    tabId: "portal-settings",
    tabSectionKey: "portalSettings",
    attributeKey: "btnParentPortal",
    attributeValue: "",
  },
  {
    tabId: "portal-settings",
    tabSectionKey: "portalSettings",
    attributeKey: "btnSubPortal",
    attributeValue: "",
  },
  {
    tabId: "portal-settings",
    tabSectionKey: "portalSettings",
    attributeKey: "language",
    attributeValue: "",
  },
  {
    tabId: "portal-settings",
    tabSectionKey: "portalSettings",
    attributeKey: "btnSave",
    attributeValue: "",
  },
] as const;

export const DefaultTranslationUserAttributes = [
  {
    tabId: "user-attributes",
    tabSectionKey: "header",
    attributeKey: "userAttributesText",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "header",
    attributeKey: "userAttributesDsc",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributesGrid",
    attributeKey: "attributesAdded",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributesGrid",
    attributeKey: "addNewAttribute",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributeModal",
    attributeKey: "editAttribute",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributeModal",
    attributeKey: "editAttributeBtn",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributesGrid",
    attributeKey: "order",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributesGrid",
    attributeKey: "attribute",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributesGrid",
    attributeKey: "attributeKey",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributesGrid",
    attributeKey: "dataType",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributesGrid",
    attributeKey: "mandatory",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributesGrid",
    attributeKey: "btnEdit",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributesGrid",
    attributeKey: "btnAll",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributesGrid",
    attributeKey: "showRows",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributesGrid",
    attributeKey: "btnPrevious",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributesGrid",
    attributeKey: "btnNext",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributeModal",
    attributeKey: "addNewAttribute",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributeModal",
    attributeKey: "attribute",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributeModal",
    attributeKey: "attributeKey",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributeModal",
    attributeKey: "mandatoryText",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributeModal",
    attributeKey: "attributeSettings",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributeModal",
    attributeKey: "availableText",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributeModal",
    attributeKey: "viewOnlyText",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributeModal",
    attributeKey: "editableText",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributeModal",
    attributeKey: "activeText",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributeModal",
    attributeKey: "dataType",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributeModal",
    attributeKey: "orderNumber",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributeModal",
    attributeKey: "btnAddNewAttribute",
    attributeValue: "",
  },
  {
    tabId: "user-attributes",
    tabSectionKey: "userAttributeModal",
    attributeKey: "editAttributeHeader",
    attributeValue: "",
  },
] as const;
